<template>
    <templatePublicComponent>
        <div>
            <div class="content">
                <a href="https://www.google.ca/maps/place/Sainte-Catherine,+QC/@45.3963235,-73.5613225,15z/data=!4m2!3m1!1s0x4cc9121fb036bcd7:0xb2365e3cb1b203bc?hl=fr">
                    <img width="100%" align="center" src="@/assets/img/ste-catherine.jpg">
                </a>
                <div style="margin-top:20px;font-size:16px;">Nous offrons le déneigement aux résidents de la ville de Ste-Catherine avec notre partenaire Déneigement R. M. Viau</div>
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Secteur.vue